import { Crosshair, UserRound, Sparkles, MapPin, Gem, BadgeEuro, HeartHandshake, FileText, BookOpen } from "lucide-react";
import { Marquee } from "./Marquee";
import { Reveal } from "./Reveal";

// The Hero image continues behind this section; translucent glass cards let it
// show through — no opaque background, no per-card backdrop-filter (kept off for
// perfectly smooth motion).
const HERO_BG = "https://images.pexels.com/photos/9400976/pexels-photo-9400976.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

const ITEMS = [
  { key: "perso", icon: Crosshair, title: "Voyages 100 % personnalisés", desc: "Aucun voyage préconçu : chaque projet est imaginé exclusivement selon vos envies." },
  { key: "planner", icon: UserRound, title: "Votre Travel Planner dédié", desc: "Chaque itinéraire est étudié, optimisé et validé par un véritable expert du voyage." },
  { key: "concierge", icon: Sparkles, title: "Concierge IA disponible 24h/24", desc: "Des réponses instantanées à tout moment, avec toujours la validation d'un conseiller humain." },
  { key: "itineraire", icon: MapPin, title: "Itinéraires créés sur mesure", desc: "Chaque étape est pensée selon votre budget, vos envies et votre manière de voyager." },
  { key: "adresses", icon: Gem, title: "Adresses sélectionnées avec soin", desc: "Des hôtels et expériences choisis pour leur qualité et leur authenticité, jamais parce qu'ils sont les plus vendus." },
  { key: "tarifs", icon: BadgeEuro, title: "Tarifs négociés", desc: "Grâce à notre réseau de partenaires, profitez des meilleures conditions au meilleur rapport qualité-prix." },
  { key: "accompagnement", icon: HeartHandshake, title: "Un accompagnement jusqu'à votre retour", desc: "Un interlocuteur unique vous accompagne avant, pendant et après votre voyage." },
  { key: "devis", icon: FileText, title: "Devis gratuit & sans engagement", desc: "Recevez une proposition personnalisée gratuitement, sans aucune obligation de réservation." },
  { key: "carnet", icon: BookOpen, title: "Votre carnet de voyage personnalisé", desc: "Un carnet clair, détaillé et entièrement conçu pour votre itinéraire, pour voyager en toute sérénité." },
];

const Card = ({ item }) => {
  const { icon: Icon, title, desc } = item;
  return (
    <div
      data-testid={`philosophy-card-${item.key}`}
      className="group relative w-[290px] md:w-[330px] h-[260px] md:h-[280px] mx-3 rounded-2xl p-7 flex flex-col
                 border border-white/15 shadow-[0_20px_50px_-24px_rgba(0,0,0,0.9)]
                 transition-[transform,border-color] duration-500 ease-out
                 hover:-translate-y-1.5 hover:border-[#E4DCCF]/45"
      style={{ background: "linear-gradient(180deg, rgba(18,19,14,0.74) 0%, rgba(18,19,14,0.62) 100%)" }}
    >
      {/* luminous top edge for a lit, glassy feel */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/50 to-transparent" aria-hidden />
      <span className="w-11 h-11 rounded-full bg-[#E4DCCF]/18 border border-[#E4DCCF]/35 flex items-center justify-center shrink-0">
        <Icon className="h-5 w-5 text-[#F1E9DA]" strokeWidth={1.6} />
      </span>
      <h3 className="font-serif-display text-xl md:text-[1.35rem] text-white leading-snug mt-5">{title}</h3>
      <p className="text-sm text-white/85 leading-relaxed mt-2.5">{desc}</p>
    </div>
  );
};

export const Reassurance = () => (
  <section className="relative overflow-hidden" data-testid="reassurance-section">
    {/* Hero continuation background */}
    <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${HERO_BG})` }} aria-hidden />
    {/* Strong legibility scrim so the bright image never washes out text — Hero still reads through the tint */}
    <div className="absolute inset-0" style={{ backgroundColor: "rgba(15,16,11,0.82)" }} aria-hidden />
    {/* Seamless fade in from Hero (top) and out to page (bottom) — kept short so it never washes out the cards */}
    <div className="absolute top-0 inset-x-0 h-40" style={{ background: "linear-gradient(180deg, #1A1B18 0%, rgba(26,27,24,0) 100%)" }} aria-hidden />
    <div className="absolute bottom-0 inset-x-0 h-24" style={{ background: "linear-gradient(180deg, rgba(250,249,246,0) 0%, #FAF9F6 100%)" }} aria-hidden />
    {/* Warm depth glow behind the heading */}
    <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at top, rgba(228,220,207,0.12), transparent 60%)" }} aria-hidden />

    <div className="relative z-10 pt-20 md:pt-24 pb-28">
      <Reveal className="max-w-2xl mx-auto text-center px-6">
        <p className="label-eyebrow text-[#E4DCCF]">Notre philosophie</p>
        <p className="font-serif-display text-3xl md:text-4xl text-white mt-5 leading-tight">
          Chez DealTravel, nous ne proposons pas des voyages préconçus.
        </p>
        <p className="text-base text-white/80 mt-5 leading-relaxed">
          Nous imaginons chaque itinéraire selon vos envies, votre budget et votre manière de voyager.
          Découvrez ce qui fait toute la différence.
        </p>
      </Reveal>

      <div className="mt-14">
        <Marquee items={ITEMS} className="py-6" renderItem={(it) => <Card item={it} />} />
      </div>
    </div>
  </section>
);

export default Reassurance;
